<app-base-page>
  <div class="select-page">
    <img
      src="https://kleksi.com/img/logo_kleksi_app_white.png"
      class="logoImg"
    />

    <span class="page-title" i18n>Kies een applicatie</span>

    <mat-form-field class="application-search" appearance="outline">
      <mat-label i18n>Zoek applicatie</mat-label>
      <input
        matInput
        type="search"
        autocomplete="off"
        [(ngModel)]="searchTerm"
      />
    </mat-form-field>

    <div class="applications-container">
      <button
        mat-basic-button
        class="application"
        *ngFor="let application of filteredApplications"
        (click)="selectApplication(application)"
      >
        {{ application.name }}
      </button>

      <span class="empty-search" *ngIf="filteredApplications.length === 0" i18n>
        Geen applicaties gevonden
      </span>
    </div>
  </div>
</app-base-page>
